import { ContentBlock } from "@/types";
import { createSecurityServiceContent } from "@/content/services/service-content-helpers";

export const content: ContentBlock[] = [
  ...createSecurityServiceContent({
    serviceName: "alarm systems",
    summary:
      "A good alarm system is built around how people move through the property. Ozy Wide Group can help plan zones, sensors, keypads, sirens and alerts so the system protects likely entry points without becoming difficult to use day to day.",
    suitedTo: [
      "family homes",
      "small businesses",
      "retail stores",
      "offices",
      "warehouses",
      "after-hours premises",
    ],
    includes: [
      "intruder alarm setup",
      "sensor positioning",
      "keypad or app controls",
      "siren configuration",
      "alarm maintenance and troubleshooting",
    ],
    notes: [
      "entry points",
      "pets",
      "staff access",
      "after-hours routines",
      "monitoring needs",
      "false alarm risks",
    ],
    process: [
      "Confirm how the property is used during business hours, after hours and overnight.",
      "Place sensors and controls so the alarm supports normal routines while still covering vulnerable areas.",
      "Test the system, user codes and alert flow before handover.",
    ],
    faq: [
      "Alarm zoning is useful when only part of a property needs to be armed at certain times.",
      "Pet movement, roller doors, drafts and loose fittings should be considered to reduce false alarms.",
      "Older alarms can often be assessed for sensor, battery, siren or control-panel issues.",
    ],
  }),
];
